// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-group.type {
    align-items: flex-start;
    margin-right: 15px;
}

.error-text {
    color: var(--danger-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/AddActivity/AddActivity.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".search-group.type {\n    align-items: flex-start;\n    margin-right: 15px;\n}\n\n.error-text {\n    color: var(--danger-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
